let ActiveNotibySMS = function(item) {
    localStorage.removeItem('accountSMS')
    localStorage.setItem('accountSMS', item.accountSMS); 
    this.accountSMS = (!isNaN(localStorage.getItem('accountSMS'))) ? parseInt(localStorage.getItem('accountSMS')) : false;
};
export default ActiveNotibySMS;
